export default "__VITE_ASSET__k41BB8PO__"